export class UnitConverter {
  private metresToSurveyFeetRatio = 1200 / 3937;
  private metresToFeetRatio = 0.3048;
  private allowedUnits = new Set(['ft', 'sft', 'm']);

  public convert(value, fromUnits, toUnits, fixedLength=null) {
    if (!this.allowedUnits.has(fromUnits) || !this.allowedUnits.has(toUnits)) {
      throw new Error('Units must either be "m", "sft", or "ft"');
    }

    if (isNaN(value)) {
      throw new Error('Value must be a number');
    }

    let convertedValue = value;

    if (fromUnits !== toUnits) {
      if (fromUnits === 'ft' || fromUnits === 'sft') {
        convertedValue *= (fromUnits === 'ft' ? this.metresToFeetRatio : this.metresToSurveyFeetRatio);
      }

      if (toUnits === 'ft' || toUnits === 'sft') {
        convertedValue /= (toUnits === 'ft' ? this.metresToFeetRatio : this.metresToSurveyFeetRatio);
      }
    }

    if (fixedLength !== null) {
      convertedValue = parseFloat(convertedValue.toFixed(fixedLength));
    }

    return convertedValue;
  }
}
